import { useSelector } from 'react-redux';
import { dataSelector } from '@nextiva/global-store';
import { isValidEmail } from 'utils/validators';

export function useSuggestedContactEmail() {
  const globalStoreData = useSelector(dataSelector);
  const suggestion: string =
    globalStoreData.user?.email ?? globalStoreData.user?.loginId;
  const isEmail = isValidEmail(suggestion);
  return isEmail ? suggestion : '';
}
